import { render, staticRenderFns } from "./Shareboard.vue?vue&type=template&id=d09fd0a0&scoped=true"
import script from "./Shareboard.vue?vue&type=script&lang=js"
export * from "./Shareboard.vue?vue&type=script&lang=js"
import style0 from "./Shareboard.vue?vue&type=style&index=0&id=d09fd0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09fd0a0",
  null
  
)

export default component.exports